import React, { useEffect, useState,useImperativeHandle,forwardRef, useMemo, } from "react";
import IconButton from "@material-ui/core/IconButton";
import EditIcon from "@material-ui/icons/Edit";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import MultiStepDropdown from "./MultiStepDropdown";
import { filterByKeyValue } from "../../helpers/dataHelper";
import "./subcourseStyle.css";
import ContentType from "../../enums/ContentType";
import TaskStatus from "../../enums/TaskStatus";
import { GetSegmentCourses, GetSegmentTopics, GetSegmentAchievements, GetSegmentCoursesInfo, GetSegmentTopicsInfo, GetSegmentAchievementsInfo } from "../../api/CMS";
import Loader from "@material-ui/core/CircularProgress";
import { toast } from "react-toastify";
import ConfirmCheckbox from "./ConfirmCheckbox";
const groupByTitle = (items) => {
  return items.reduce((acc, curr) => {
    if (!acc[curr.Title]) acc[curr.Title] = [];
    acc[curr.Title].push(curr);
    return acc;
  }, {});
};

const SubCourses = forwardRef(({
  segmentId,
  classTypeId,
  CourseId,
  examTypeId,
  getSelectedSubTopic,
  nextQuestion,
  previousQuestion,
  questionData,
  questionSelectedTopicsData,
  updateQuestionInfo,
  onLabelsUpdate,
  setLoader,
  loader,
  allSegmentData
}, ref) => {
  const user = JSON.parse(localStorage.getItem("user"));
  // const allData = JSON.parse(localStorage.getItem("MaarifModelData"));
  // const filteredMainData = filterByKeyValue(
  //   allData,
  //   "ClassTypeId",
  //   classTypeId
  // );

  // Controlled dropdown states




  const [selectedSegment, setSelectedSegment] = useState(null);
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [selectedSubCourseTopic, setSelectedSubCourseTopic] = useState(null);
  const [selectedAchievement, setSelectedAchievement] = useState(null);
  const [selectedLabels, setSelectedLabels] = useState({
    segmentName:null,
    courseName: null,
    topicName: null,
    subTopicName: null,
    achievementName: null,
  });
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [pendingAction, setPendingAction] = useState(null);
  const [isSegmentChanged, setIsSegmentChanged] = useState(false);
  const [isCourseChanged, setIsCourseChanged] = useState(false);
  const [isSubTopicChanged, setIsSubTopicChanged] = useState(false);
  const [isAchievementChanged, setIsAchievementChanged] = useState(false);
  // const [loader,setLoader] = useState(false)
  const [courses, setCourses] = useState([]);
  const [topics, setTopics] = useState({});
  const [achievements, setAchievements] = useState([]);
  const [skipChecked, setSkipChecked] = useState(false);
  const [incompatibleChecked, setIncompatibleChecked] = useState(false);
  const [achivementDropdownOnAlarm, setAchivementDropdownOnAlarm] = useState(false);
  const [confirmNoAchievement, setConfirmNoAchievement] = useState(false);
  const [confirmMultiAchievement, setConfirmMultiAchievement] = useState(false);
  const [achievementsLoading, setAchievementsLoading] = useState(false);

  useEffect(() => {
    if (!questionData) return;
  
    const isSkipped = questionData.CMSStatus === TaskStatus.Skipped;
    const isIncompatible = questionData.CMSStatus === TaskStatus.Incompatible
    console.log("Sync skipChecked:", isSkipped, questionData.CMSStatus);
    setSkipChecked(isSkipped);
    setIncompatibleChecked(isIncompatible)
  }, [questionData.CMSStatus, questionData]);
  
  const segment = useMemo(() => {
    if (!Array.isArray(allSegmentData) || !questionSelectedTopicsData.SegmentId) return null;
    return allSegmentData.find((c) => c.Id === questionSelectedTopicsData.SegmentId) || null;
  }, [allSegmentData, segmentId]);
  const segmentName = useMemo(() => {
    if (!segment) return null;
    const { ClassTypeName, ExamTypeId, ExamTypeName } = segment;
    return `${ClassTypeName}${ExamTypeId > 0 ? ` - ${ExamTypeName}` : ""}`;
  }, [segment]);

  useEffect(() => {
    if (questionSelectedTopicsData && questionSelectedTopicsData.SegmentCourseId ) {
      setSelectedSegment(questionSelectedTopicsData.SegmentId)
      initializeDropdowns();
    }
  }, [questionSelectedTopicsData]);
  
  const initializeDropdowns = async () => {
    try {
      setLoader(true);
      setAchievementsLoading(true);
      // 1️⃣ Fetch courses for segment
      const courseRes = await GetSegmentCoursesInfo(questionSelectedTopicsData.SegmentId, user.Token);
      if (courseRes.data.ResponseStatus === 1) {
        const allCourses = courseRes.data.ResponseData;
        setCourses(allCourses);
  
        // Preselect current question’s course
        const matchedCourse = allCourses.find(c => c.Id === questionSelectedTopicsData.SegmentCourseId);
        if (matchedCourse) {
          setSelectedCourse(matchedCourse.Id);
          setSelectedLabels(prev => ({ ...prev, courseName: matchedCourse.Name }));
  
          // 2️⃣ Fetch topics/subtopics for that course
          await fetchTopicsAndSelect(matchedCourse.Id);
        }
        if (questionSelectedTopicsData.AchievementId === -1) {
          setSelectedAchievement(-1);
          setSelectedLabels(prev => ({ ...prev, achievementName: "Kazanımı bu listede bulamıyorumr" }));
          return; // skip matching fetch logic since it’s custom
        }
        if (questionSelectedTopicsData.AchievementId === -2) {
          setSelectedAchievement(-2);
          setSelectedLabels(prev => ({ ...prev, achievementName: "Bu listedeki birden fazla kazanımı kapsıyor" }));
          return; // skip matching fetch logic since it’s custom
        }
      }
    } catch (error) {
      // toast.error("Kurs bilgileri alınamadı");
    } finally {
      setLoader(false);
    }
  };

  const fetchCourses = async (segmentId) => {
    try {
      setLoader(true);
      setAchievementsLoading(true);
      // 1️⃣ Fetch courses for segment
      const courseRes = await GetSegmentCoursesInfo(segmentId, user.Token);
      if (courseRes.data.ResponseStatus === 1) {
        const allCourses = courseRes.data.ResponseData;
        setCourses(allCourses);
  
        // Preselect current question’s course
        // const matchedCourse = allCourses.find(c => c.Id === questionSelectedTopicsData.SegmentCourseId);
        // if (matchedCourse) {
        //   setSelectedCourse(matchedCourse.Id);
        //   setSelectedLabels(prev => ({ ...prev, courseName: matchedCourse.Name }));
  
        //   // 2️⃣ Fetch topics/subtopics for that course
        //   await fetchTopicsAndSelect(matchedCourse.Id);
        // }
        // if (questionSelectedTopicsData.AchievementId === -1) {
        //   setSelectedAchievement(-1);
        //   setSelectedLabels(prev => ({ ...prev, achievementName: "Kazanım Yoktur" }));
        //   return; // skip matching fetch logic since it’s custom
        // }
      }
    } catch (error) {
      // toast.error("Kurs bilgileri alınamadı");
    } finally {
      setLoader(false);
    }
  };
  
  const fetchTopicsAndSelect = async (courseId) => {
    try {
      setLoader(true);
      setAchievementsLoading(true);
      const topicRes = await GetSegmentTopicsInfo(courseId, user.Token);
      if (topicRes.data.ResponseStatus === 1) {
        const grouped = groupByTitle(topicRes.data.ResponseData);
        setTopics(grouped);
  
        // Preselect subtopic
        const matchedSub = topicRes.data.ResponseData.find(t => t.Id === questionSelectedTopicsData.SegmentTopicId);
        if (matchedSub) {
          setSelectedSubCourseTopic(matchedSub.Id);
          setSelectedLabels(prev => ({
            ...prev,
            topicName: matchedSub.Title,
            subTopicName: matchedSub.Name
          }));
  
          // 3️⃣ Fetch achievements if exist
          await fetchAchievements(matchedSub.Id);
        }
      }
    } catch {
      // toast.error("Konu bilgileri alınamadı");
    }
    finally {
      setLoader(false);
    }
  };
  
  const fetchAchievements = async (subTopicId) => {
    try {
      setLoader(true);
      setAchievementsLoading(true);
      const res = await GetSegmentAchievementsInfo(subTopicId, user.Token);
      if (res.data.ResponseStatus === 1 && res.data.ResponseData.length > 0) {
        setAchievements(res.data.ResponseData);
        const matchedAch = res.data.ResponseData.find(
          a => a.AchievementId === questionSelectedTopicsData.AchievementId
        );
        if (matchedAch) {
          setSelectedAchievement(matchedAch.AchievementId);
          setSelectedLabels(prev => ({ ...prev, achievementName: matchedAch.Name }));
        }
      }else{
        setAchievements([])
      }
    } catch {
      // toast.error("Kazanımlar alınamadı");
    }finally {
      setLoader(false);
      setAchievementsLoading(false);
    }
  };
  





  // Prefill defaults
  // useEffect(() => {
  //   if (questionSelectedTopicsData) {
  //     setSelectedCourse(questionSelectedTopicsData.CourseId || null);
  //     setSelectedSubCourseTopic(
  //       questionSelectedTopicsData.SubCourseTopicUniqueId || null
  //     );
  //     setSelectedAchievement(questionSelectedTopicsData.AchievementId || null);
  //   }
  // }, [questionSelectedTopicsData]);



  const resetDropdownStates = () => {
    setIsSegmentChanged(false)
    setIsCourseChanged(false);
    setIsSubTopicChanged(false);
    setIsAchievementChanged(false);
    setSelectedCourse(null);
    setSelectedSubCourseTopic(null);
    setSelectedAchievement(null);
    setSelectedLabels({
      segmentName:null,
      courseName: null,
      topicName: null,
      subTopicName: null,
      achievementName: null,
    });
    setSkipChecked(false);
    setAchivementDropdownOnAlarm(false);
    setConfirmNoAchievement(false);
    setConfirmMultiAchievement(false);

  };

  // 👇 expose it AFTER it’s defined
  useImperativeHandle(ref, () => ({
    resetDropdownStates,
  }));

  
  // const normalizeValue = (val) => (val === 0 ? null : val);
  const normalizeValue = (val) => {
    if (val === 0) return null;
    if (val === undefined) return null;
    if (val === -1) return -1; // ✅ preserve -1 as a real value
    return val;
  };

  const hasUnsavedChanges =
    selectedSegment !== questionSelectedTopicsData.SegmentId ||
    selectedCourse !== questionSelectedTopicsData.SegmentCourseId ||
    normalizeValue(selectedSubCourseTopic) !== normalizeValue(questionSelectedTopicsData.SegmentTopicId) ||
    normalizeValue(selectedAchievement) !== normalizeValue(questionSelectedTopicsData.AchievementId);
    useEffect(() => {
      if (hasUnsavedChanges) {
        setSkipChecked(false);
      } else if (questionData.CMSStatus === TaskStatus.Skipped) {
        setSkipChecked(true);
      }
    }, [hasUnsavedChanges, questionData.CMSStatus]);
    
  
  // const handleNavigate = (direction) => {
  //   if (hasUnsavedChanges) {
  //     setPendingAction(direction);
  //     setShowConfirmModal(true);
  //   } else {
  //     if(questionReported){
  //       updateQuestionInfo(questionSelectedTopicsData.SubCourseTopicUniqueId,ContentType.SubCourseTopic,TaskStatus.HasError)
  //     }else{
  //       updateQuestionInfo(questionSelectedTopicsData.SubCourseTopicUniqueId,ContentType.SubCourseTopic,TaskStatus.Skipped)

  //     }
  //     direction === "next" ? nextQuestion() : previousQuestion();
  //   }
  // };

  console.log("selectedAchievement",selectedAchievement);


  const handleNavigate = async (direction) => {
    if (loader) return;

  
    // 1️⃣ Incompatible override (highest priority)
    if (incompatibleChecked) {
      await updateQuestionInfo(undefined, undefined, TaskStatus.Incompatible);
      direction === "next" ? nextQuestion() : previousQuestion();
      return;
    }
    const effectiveAchievement = achievements.length === 0 ? -1 : selectedAchievement;
    if (!effectiveAchievement) {
      setAchivementDropdownOnAlarm(true);
      toast.error("Lütfen Kazanım Seçiniz!");
      return;
    }
  
    // 3️⃣ Handle unsaved changes (show confirmation modal)
    if (hasUnsavedChanges) {
      setPendingAction(direction);
      setShowConfirmModal(true);
      return;
    }
  
    // 4️⃣ Handle skipped status
    if (skipChecked) {
      await updateQuestionInfo(undefined, undefined, TaskStatus.Skipped);
    }
  
    // 5️⃣ Proceed to next/previous question
    direction === "next" ? nextQuestion() : previousQuestion();
  };
  
  const handleSegmentChange =async (id) => {
    setSelectedSegment(id);
    if (id !== questionSelectedTopicsData.SegmentId) {
      setIsSegmentChanged(true);
      setIsCourseChanged(true);
      setIsSubTopicChanged(true);
      setIsAchievementChanged(true);
    fetchCourses(id)
    } else {
      setIsSegmentChanged(false);
      initializeDropdowns()
    }
    // await fetchTopicsAndSelect(id);
    // setIsCourseChanged(false)
    // setIsSubTopicChanged(false);
    // setIsAchievementChanged(false);
    setSelectedCourse(null)
    setSelectedSubCourseTopic(null)
    setSelectedAchievement(null)
  };

  const handleCourseChange =async (id) => {
    setSelectedCourse(id);
    if (id !== questionSelectedTopicsData.SegmentCourseId) {
      setIsCourseChanged(true);
    } else {
      setIsCourseChanged(false);
    }
    await fetchTopicsAndSelect(id);
    setIsSubTopicChanged(false);
    setIsAchievementChanged(false);
    setSelectedSubCourseTopic(null)
    setSelectedAchievement(null)
    updateQuestionInfo(id,ContentType.Courses)
    if(questionData.CMSStatus === TaskStatus.Incompatible){
      setIncompatibleChecked(false)
    }
  };

  const handleSubTopicChange = async(id) => {
    setSelectedSubCourseTopic(id);
    if (id !== questionSelectedTopicsData.SegmentTopicId) {
      setIsSubTopicChanged(true);
    } else setIsSubTopicChanged(false);

    await fetchAchievements(id);
    setIsAchievementChanged(false);
    setSelectedAchievement(null)
    updateQuestionInfo(id,ContentType.SubCourseTopic)
    if(questionData.CMSStatus === TaskStatus.Incompatible){
      setIncompatibleChecked(false)
    }
  };

  const handleAchievementChange = (id) => {
    setSelectedAchievement(id);
    if (id !== questionSelectedTopicsData.AchievementId) {
      setIsAchievementChanged(true);
    } else setIsAchievementChanged(false);
    updateQuestionInfo(id,ContentType.Achievement)
    if(questionData.CMSStatus === TaskStatus.Incompatible){
      setIncompatibleChecked(false)
    }
  };

  const handleConfirm = () => {
    // 🔥 You can call your API here to save new selection before moving on
    const payload = {
      // ExamType: examTypeId,
      CourseId: selectedCourse,
      CourseTopicId: null, // can extract if needed
      SubCourseTopicUniqueId: selectedSubCourseTopic,
      AchievementId: selectedAchievement,
    };
    resetDropdownStates();
    // Then move to next/prev
    if (pendingAction === "next") nextQuestion();
    if (pendingAction === "prev") previousQuestion();
    setShowConfirmModal(false);
  };

  const handleCancel = () => {
    setShowConfirmModal(false);
  };

  const handleLabelsChange = (labels) => {
    setSelectedLabels(labels);
    if (typeof onLabelsUpdate === "function") {
     if(hasUnsavedChanges) {

       onLabelsUpdate(labels); // ✅ send to parent
     }else{

      setSelectedLabels({
        segmentName:null,
        courseName: null,
        topicName: null,
        subTopicName: null,
        achievementName: null,
      });
      onLabelsUpdate({
        courseName: null,
        topicName: null,
        subTopicName: null,
        achievementName: null,
      });
     }
    }
  };


  const isConfirmDisabled =
  (selectedAchievement === -1 && !confirmNoAchievement) ||
  (selectedAchievement === -2 && !confirmMultiAchievement);


  return (
    <div className="subcourse-container">
      {/* Loader container */}
      {loader && (
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
            }}
          >
            <Loader size={100} />
          </div>
        )}
      {!loader&&<div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-end",
        }}
      >
        {/* <button
          style={{ display: "flex", alignItems: "center" }}
          onClick={() => handleNavigate("prev")}
          className="nav-btn"
        >
          <ArrowBackIcon /> Önceki
        </button> */}
        <button
          style={{ display: "flex", alignItems: "center" }}
          onClick={() => handleNavigate("next")}
          className="nav-btn"
        >
          Sonraki <ArrowForwardIcon />
        </button>
      </div>}

      <MultiStepDropdown
      segmentId={selectedSegment}
        courses={courses}
        topics={topics}
        achievements={achievements}
        selectedCourse={selectedCourse}
        selectedSubCourseTopic={selectedSubCourseTopic}
        selectedAchievement={selectedAchievement}
        onChangeCourse={handleCourseChange}
        onChangeSubCourseTopic={handleSubTopicChange}
        onChangeAchievement={handleAchievementChange}
        isSegmentChanged={isSegmentChanged}
        isCourseChanged={isCourseChanged}
        isSubTopicChanged={isSubTopicChanged}
        isAchievementChanged={isAchievementChanged}
        onLabelsChange={handleLabelsChange}
        allSegmentData={allSegmentData}
        handleSegmentChange={handleSegmentChange}
        achivementDropdownOnAlarm={achivementDropdownOnAlarm}
        achievementsLoading={achievementsLoading}
      />
     {(!hasUnsavedChanges && normalizeValue(questionSelectedTopicsData.AchievementId) )&& (
  <div
    style={{
      marginTop: "8px",
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      gap: "8px",
      opacity: hasUnsavedChanges || incompatibleChecked ? 0.5 : 1, // 👈 dim when disabled
      pointerEvents: hasUnsavedChanges || incompatibleChecked ? "none" : "auto", // prevent interaction
    }}
  >
    <input
      type="checkbox"
      id="skipCheckbox"
      checked={skipChecked}
      disabled={hasUnsavedChanges || incompatibleChecked}
      onChange={(e) => setSkipChecked(e.target.checked)}
      style={{
        transform: "scale(1.4)",
        cursor: hasUnsavedChanges || incompatibleChecked ? "not-allowed" : "pointer",
      }}
    />
    <label
      htmlFor="skipCheckbox"
      style={{
        fontSize: "15px",
        userSelect: "none",
        cursor: hasUnsavedChanges || incompatibleChecked ? "not-allowed" : "pointer",
      }}
    >
      Değişikliğe gerek yoktur. Bilgiler Doğru.
    </label>
  </div>
  
)}
{(
  <div
    style={{
      marginTop: "8px",
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      gap: "8px",
      opacity:  skipChecked ? 0.5 : 1, // 👈 dim when disabled
      pointerEvents:  skipChecked ? "none" : "auto", // prevent interaction
    }}
  >
    <input
      type="checkbox"
      id="incompatibleCheckbox"
      checked={incompatibleChecked}
      disabled={ skipChecked}
      onChange={(e) => setIncompatibleChecked(e.target.checked)}
      style={{
        transform: "scale(1.4)",
        cursor:  skipChecked ? "not-allowed" : "pointer",
      }}
    />
    <label
      htmlFor="incompatibleCheckbox"
      style={{
        fontSize: "15px",
        userSelect: "none",
        cursor:  skipChecked ? "not-allowed" : "pointer",
      }}
    >
      {`${segmentName} için kullanılması uygun değildir.`}
    </label>
  </div>
)}


{showConfirmModal && (
  <div className="modal">
    <div className="modal-content confirm-modal">
      <button className="close-btn" onClick={handleCancel}>✕</button>

      <div className="modal-body">
       
        

       {
     ( isSegmentChanged&&(selectedSubCourseTopic==null))? (<h3>
        Herhangi bir konu seçimi yapmadınız değişiklikleriniz kayıt edilmeyecektir.


       </h3>)
       
       :
       <>
        <h3 className="modal-title">Yaptığınız Değişiklikler için Emin misiniz?</h3>

       <div className="modal-section">
          <h4 className="section-title">Eski Seçim</h4>
          <ul className="selection-list">
            {/* {questionSelectedTopicsData.CourseName} →{" "}
            {questionSelectedTopicsData.NewSubCourseTopicName} →{" "}
            {questionSelectedTopicsData.AchievementName} */}
            <li style={{padding:3,backgroundColor: isSegmentChanged?"rgb(252 165 165)":null}} >Sınıf ve Sınav Türü: {segmentName || "-"}</li>
            <li style={{padding:3,backgroundColor: isCourseChanged?"rgb(252 165 165)":null}} >Ders: {questionSelectedTopicsData.CourseName || "-"}</li>
            <li style={{padding:3,backgroundColor: selectedLabels.topicName !== questionSelectedTopicsData.CourseTopicName ?"rgb(252 165 165)":null}}>Konu: {questionSelectedTopicsData.CourseTopicName || "-"}</li>
            <li style={{padding:3,backgroundColor: isSubTopicChanged?"rgb(252 165 165)":null}}>Alt Konu: {questionSelectedTopicsData.SubCourseTopicName || "-"}</li>
            <li style={{padding:3,backgroundColor: isAchievementChanged?"rgb(252 165 165)":null}}>Kazanım: {questionSelectedTopicsData.AchievementName || (questionSelectedTopicsData.AchievementId === -1 && "Kazanım Bulunamadı") || (questionSelectedTopicsData.AchievementId === -2 && "Çoklu Kazanım") ||  "-"}</li>
          </ul>
        </div>

        <div className="modal-section">
          <h4 className="section-title">Yeni Seçim</h4>
          <ul className="selection-list">
            <li style={{padding:3,backgroundColor: isSegmentChanged?" rgb(134 239 172)":null}} >Sınıf ve Sınav Türü: <strong>{selectedLabels.segmentName || "-"}</strong></li>
            <li style={{padding:3,backgroundColor: isCourseChanged?" rgb(134 239 172)":null}} >Ders: <strong>{selectedLabels.courseName || "-"}</strong></li>
            <li style={{padding:3,backgroundColor: selectedLabels.topicName !== questionSelectedTopicsData.CourseTopicName?" rgb(134 239 172)":null}}>Konu: <strong>{selectedLabels.topicName || "-"}</strong></li>
            <li style={{padding:3,backgroundColor: isSubTopicChanged?" rgb(134 239 172)":null}}>Alt Konu: <strong>{selectedLabels.subTopicName || "-"}</strong></li>
            <li style={{padding:3,backgroundColor: isAchievementChanged?" rgb(134 239 172)":null}}>Kazanım: <strong>{selectedLabels.achievementName || "-"}</strong></li>
          </ul>
        </div>
       </>
        }
      </div>

      {/* {selectedAchievement === -1 && (
  <div
    style={{
      marginTop: "20px",
      padding: "10px",
      borderTop: "1px solid #ddd",
    }}
  >
    <label
      htmlFor="confirmNoAchievement"
      style={{
        display: "block",
        marginBottom: "8px",
        fontSize: "15px",
        fontWeight: "500",
        color: "#374151",
      }}
    >
      {"“Kazanım Yoktur” seçtiniz. Sorunun doğru konuya atandığına emin misiniz?"}
    </label>

    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "8px",
        marginLeft: "4px",
      }}
    >
      <input
        type="checkbox"
        id="confirmNoAchievement"
        checked={confirmNoAchievement}
        onChange={(e) => setConfirmNoAchievement(e.target.checked)}
        style={{
          transform: "scale(1.4)",
          cursor: "pointer",
        }}
      />
      <label
        htmlFor="confirmNoAchievement"
        style={{
          fontSize: "15px",
          cursor: "pointer",
          userSelect: "none",
        }}
      >
        Eminim
      </label>
    </div>
  </div>
)} */}

<ConfirmCheckbox
  id="noAchievementConfirm"
  condition={selectedAchievement === -1}
  label="‘Kazanım Bulunamadı’ seçtiniz. Sorunun doğru konuya atandığından emin misiniz?"
  confirmText="Eminim"
  confirmed={confirmNoAchievement}
  onChange={setConfirmNoAchievement}
/>

<ConfirmCheckbox
  id="multiAchievementConfirm"
  condition={selectedAchievement === -2}
  label="Birden fazla kazanım içeren sorularda, soruyu kapsayan son kazanım seçilebilir. Bu soruyu çoklu kazanım olarak işaretlemeyi onaylıyor musunuz?"
  confirmText="Onaylıyorum"
  confirmed={confirmMultiAchievement}
  onChange={setConfirmMultiAchievement}
/>


<div className="modal-actions">
  <button className="modal-btn cancel" onClick={handleCancel}>
    Hayır
  </button>
  <button
  className="modal-btn confirm"
  onClick={handleConfirm}
  disabled={isConfirmDisabled}
  style={{
    opacity: isConfirmDisabled ? 0.6 : 1,
    cursor: isConfirmDisabled ? "not-allowed" : "pointer",
  }}
>
  Evet
</button>
</div>
    </div>
  </div>
)}

    </div>
  );
});

export default SubCourses;
